import initialStore from "../../initialStore";
import {
    SET_REMOVE_CURRENCY,
    SET_SINGLE_CLIENT,
} from "@actions/actionTypes";

export default function singleClient(state = initialStore.emptyObj, action) {
    switch (action.type) {
        case SET_SINGLE_CLIENT:
            return  action.client
        case SET_REMOVE_CURRENCY:
            return action.client
        default:
            return state;
    }
}
